module.exports = __webpack_public_path__ + "static/service-banner-employee-99e32a1a7c86e0940c72d387643cfefa.jpeg";